import JsUtil from "./func/util";
import makeGrid from "./func/grid";


const coupon_btn = document.querySelector(".p-btn__coupon");
const facebook_btn = document.querySelector(".p-btn__facebook");
const twitter_btn = document.querySelector(".p-btn__twitter");
const url_btn = document.querySelector(".p-btn__url");

let layer = promokit.layer({
    el:'#layer-1',
    buttons:'.open-1',
    render:true
});

let page = promokit.page({
    el:'#container',
    type:'basic',
    cnb:true,
    topButton:true,
    footer:{
        theme:'black'
    },
    headerButton:{
        home:true,
        event:true,
        sns:true,
        theme:'black'
    },
    caution:{
        template:
        `<ol>
            <li>제재된 계정은 참여가 불가능합니다.</li>
            <li>쿠폰은 클래식 서버에서만 사용 가능하며, 아이템 수령 후 거래 및 판매 대행이 불가능합니다. </li>
            <li>설문 참여 보상 쿠폰은 2022. 6. 29.(수) 오전 10시 전까지 획득할 수 있습니다. </li>
            <li>획득한 쿠폰은 발급일로부터 30일간 사용할 수 있습니다.</li>
            <li>[이벤트]가 포함된 아이템은 이벤트 종료 후 정해진 시점에 삭제될 수 있습니다.</li>
        </ol>`
    }
});

/* 슬라이드 */
promokit.slide({
    el: '#sec1_slide',
    infinity: true,
    bullet: true,
    arrow: true,
    data:[
        `${promokit.store('staticPath')}/promo/aion/event/2022/220608_survey/img/slide1-img1.jpg`,
        `${promokit.store('staticPath')}/promo/aion/event/2022/220608_survey/img/slide1-img2.jpg`,
        `${promokit.store('staticPath')}/promo/aion/event/2022/220608_survey/img/slide1-img3.jpg`,
        `${promokit.store('staticPath')}/promo/aion/event/2022/220608_survey/img/slide1-img4.jpg`,
        `${promokit.store('staticPath')}/promo/aion/event/2022/220608_survey/img/slide1-img5.jpg`,
    ]
});

promokit.slide({
    el: '.p-layer__dungeon',
    arrow: true,
    bullet: true,
    infinity: true
});

promokit.slide({
    el: '.p-layer__field',
    arrow: true,
    bullet: true,
    infinity: true
});

/* 레이어 */
promokit.layer({
    el: '#layer-field',
    buttons: '.p-btn__field'
});

promokit.layer({
    el: '#layer-dungeon',
    buttons: '.p-btn__dungeon'
});


/* sns 공유하기 */
facebook_btn.addEventListener('click',function(e){
    e.preventDefault();
    promokit.share({
        target: 'facebook'
    });
});
twitter_btn.addEventListener('click',function(e){
    e.preventDefault();
    promokit.share({
        target: 'twitter'
    });
});

url_btn.addEventListener('click',function(e){
    e.preventDefault();
    promokit.share({
        target: 'url'
    });
});

/* 쿠폰함 */
coupon_btn.addEventListener('click',function(e){
    e.preventDefault();
    promokit.coupon();
});

/* util 추가 */
window.jsUtil = new JsUtil();

/* 설문조사 로직 */
/* 데이터를 관리할 데이터 어댑터 모듈(클로저) */
let dataAdapter = (() => {
    let check_count = 0; //체크 박스 count
    let lastPageIdx = -1; // 저장된 마지막 페이지 index
    let accountObj = {}; //계정 데이터.

    return {
        //서버에서 전달 받은 계정 정보 얕은 복사로 set.
        setAccountObj : (obj) => {
            accountObj = obj;
        },
        //서버에서 전달 받은 계정 정보 get.
        getAccountObj : () => {
            return accountObj;
        },
        //마지막 페이지 index set.
        setLastPageIdx : (idx) => {
            lastPageIdx = idx;
        },
        //마지막 페이지 index get.
        getLastPageIdx : () => {
            return lastPageIdx;
        },
        //체크 박스 count set.
        setCheck_count : (count) => {
            check_count = count;
        },
        //체크 박스 count get.
        getCheck_count : () => {
            return check_count;
        },
    };
})();

/* 임시 펑션 선언 */
window.submit_survey = (array)=>{
    return new Promise();
}

/* ajax 즉시실행함수(IIFE) */
(() => {
    $.ajax({
        url : '/events/aion/2022/220608_survey/init',
        type : 'GET',
        complete : (response) =>{
            if(response.status == 200){ //통신 성공
                try{
                    jsUtil.case('ready'); //최초 설정.
                    let jsonData = response.responseJSON;
                    if(jsonData.userAccount){
                        //데이터어댑터에 저장
                        dataAdapter.setLastPageIdx(jsonData.body.lastPageIdx);
                        dataAdapter.setAccountObj(jsonData.userAccount);

                        //설문조사 버튼 케이스 처리
                        if(jsonData.promotion.timeOver){ //기간 종료
                            jsUtil.state('.p-btn__ready','disabled');
                        }else if(dataAdapter.getLastPageIdx() === 28){ //설문 완료
                            jsUtil.state('.p-btn__ready','complete');
                        }
                    }else{ //로그인하지 않았을 경우
                        document.querySelector('.p-btn__ready').addEventListener('click',function(e){
                            e.stopImmediatePropagation();
                            promokit.login();
                        });
                    }
                }catch(err){
                }
            }
        }
    });
})();


/* 버튼별 이벤트 처리 */
document.getElementById('question_grid').addEventListener('click',async (e)=>{
    //체크박스 2개 이상 선택 불가 처리.
    if(e.target.type === 'checkbox'){
        if(e.target.checked) {
            dataAdapter.setCheck_count(dataAdapter.getCheck_count()+1);
        }
        else {
            dataAdapter.setCheck_count(dataAdapter.getCheck_count()-1);
        }
        if(dataAdapter.getCheck_count() > 2){
            e.target.checked = false;
            dataAdapter.setCheck_count(dataAdapter.getCheck_count()-1);
        }
    }

    //설문 참여하기.
    if(e.target.classList.contains('p-btn__ready')){
        let lastPageIdx = dataAdapter.getLastPageIdx();
        let accountInfo = dataAdapter.getAccountObj();

        //본인 확인 및 제재 계정 처리.
        if(!accountInfo.realName){
            promokit.message({
                type: 'alert',
                message: '본인확인이 필요합니다.',
                done: function() {
                    // 본인 확인 링크 넘길때 각 망별로 보내줘야 정상적으로 본인 확인창이 나옴
                    switch (promokit.store('network')) {
                        case 'local':
                            window.location.href="http://op.go.plaync.com/account/checkrealname";
                            break;
                        case 'op':
                            window.location.href="http://op.go.plaync.com/account/checkrealname";
                            break;
                        case 'rc':
                            window.location.href="http://rc.go.plaync.com/account/checkrealname";
                            break;
                        case 'live':
                            window.location.href="https://go.plaync.com/account/checkrealname";
                            break;
                    }
                }
            });
            return;
        }else if(accountInfo.banAccount || accountInfo.gameBanAccount){
            promokit.message({
                type: 'alert',
                message: '제재 계정은 이벤트에 참여할 수 없습니다.',
            });
            return;
        }

        //정상 처리 케이스
        if(lastPageIdx > -1 && lastPageIdx < 28){
            promokit.message({
                type: 'alert',
                message: '저장된 데이터가 있습니다.<br>이어서 진행할까요?',
                done: function() {
                    makeGrid((lastPageIdx*1)+1);
                    if(lastPageIdx < 15) document.querySelector('.p-sec2__tab--2').classList.add('on');
                    else document.querySelector('.p-sec2__tab--3').classList.add('on');
                }
            });
        }else{
            makeGrid(0);
            document.querySelector('.p-sec2__tab--1').classList.add('on');
        }
    }

    //tab 2. 데바님들의 이야기가 듣고 싶어요
    if(e.target.classList.contains('p-btn__start')){
        makeGrid(1);
    }

    //tab 3. 데바 노트에 쓰여진 데바님들의 목소리
    if(e.target.classList.contains('p-btn__confirm')){
        makeGrid(16);
    }

    //tab 3. 설문조사 완료
    if(e.target.classList.contains('p-btn__end')){
        window.scrollTo({ top: document.querySelector(".p-sec2__con3").offsetTop-100, behavior: "smooth" });
    }



    //페이지 넘김 처리.
    if(e.target.classList.contains('p-btn__next')){
        let nowNum = e.target.dataset.num*1;
        let page = e.target.dataset.page;
        let answerCount = nowNum === 28? 1:e.target.dataset.count*1;
        let answerData = [];

        try{
            let answer_type = document.querySelectorAll(`input[name=answer_${page}_0]:checked`)[0].dataset.answer*1; // 질문 분기 처리용
            for(let i=0; i<answerCount; i++){
                let answerObj={};
                let answerObj2={}; //체크 박스용 추가 객체.
                let answerNodes = document.querySelectorAll(`input[name=answer_${page}_${i}]:checked`);

                //pageIdx, pageId, questionId, answerId, answerText
                answerObj['pageIdx'] = nowNum;
                answerObj['pageId'] = page+"";
                answerObj['questionId'] = (i+1)+"";
                answerObj['answerId'] = document.querySelectorAll(`input[name=answer_${page}_${i}]:checked`)[0].dataset.answer;
                answerObj['answerText'] = document.querySelector(`#text_${page}_${i+1}_${answerObj['answerId']}`) && document.querySelector(`#text_${page}_${i+1}_${answerObj['answerId']}`).value;
                if(answerObj['answerText']===''){
                    promokit.message({
                        type: 'alert',
                        message: '기타 내용을 입력해 주세요.',
                        done: ()=>{
                            document.querySelector(`#text_${page}_${i+1}_${answerObj['answerId']}`).focus();
                        }
                    });
                    return;
                }
                answerData.push(answerObj);

                //체크 박스 문항 2개 선택 시 답변 추가로 push.
                if(answerNodes.length >= 2) {
                    answerObj2['pageIdx'] = nowNum;
                    answerObj2['pageId'] = page+"";
                    answerObj2['questionId'] = (i+1)+"";
                    answerObj2['answerId'] = document.querySelectorAll(`input[name=answer_${page}_${i}]:checked`)[1].dataset.answer;
                    answerObj2['answerText'] = document.querySelector(`#text_${page}_${i+1}_${answerObj2['answerId']}`) && document.querySelector(`#text_${page}_${i+1}_${answerObj2['answerId']}`).value;
                    if(answerObj2['answerText']===''){
                        promokit.message({
                            type: 'alert',
                            message: '기타 내용을 입력해 주세요.',
                            done: ()=>{
                                document.querySelector(`#text_${page}_${i+1}_${answerObj2['answerId']}`).focus();
                            }
                        });
                        return;
                    }
                    answerData.push(answerObj2);
                }

                //마지막 질문의 경우 "해당 항목을 선택하신 이유는 무엇인가요?" 항목 별도 추가.
                if(nowNum === 28) {
                    answerObj2['pageIdx'] = nowNum;
                    answerObj2['pageId'] = page+"";
                    answerObj2['questionId'] = "2";
                    answerObj2['answerId'] = "1";
                    answerObj2['answerText'] = document.querySelector('#text9_1').value;
                    if(answerObj2['answerText']===''){
                        promokit.message({
                            type: 'alert',
                            message: '내용을 입력해 주세요.',
                            done: ()=>{
                                document.querySelector('#text9_1').focus();
                            }
                        });
                        return;
                    }
                    answerData.push(answerObj2);
                }
            }

            // 프로미스 처리 중첩 try - catch.
            try {
                await submit_survey(answerData);
            }catch (e) {
                promokit.message({
                    type: 'alert',
                    message: `작성하신 답변이 정상적으로 전달되지 않았습니다.<br>다음 버튼을 다시 눌러 주세요.`,
                });
                return;
            }
            //질문 분기별 처리
            if(nowNum === 0 ) { //Q1
                jsUtil.case('start');
            }else if(nowNum === 15){ //Q10
                jsUtil.case('confirm');
            }else if(nowNum === 28){ //마지막 문항
                jsUtil.case('end');
            }else if(nowNum === 4 || nowNum === 8){ //Q5 티아크 연구기지 플레이 경험이 있으신가요?, Q6 해방된 파슈만디르 사원 플레이 경험이 있으신가요?
                makeGrid(nowNum+(answer_type>1?4:1));
            } else if(nowNum === 5 || nowNum === 9){ //플레이 경험은 어떠셨나요?
                makeGrid(nowNum+(answer_type<4?1:2));
            } else if(nowNum === 6 || nowNum === 10){ //어떤 부분에서 만족스러웠나요?
                makeGrid(nowNum+2);
            }else if(nowNum === 22){ //Q17 앞으로 클래식 서버에서 레벨 확장이 필요하다고 생각하시나요?
                makeGrid(nowNum+answer_type);
            }else if(nowNum === 23){ //Q17-1 레벨 확장이 되지 않을 경우 클래스 성장은 어떤 식으로 진행되길 희망하시나요?
                makeGrid(nowNum+2);
            }else{
                makeGrid(nowNum+1);
            }

            dataAdapter.setCheck_count(0); //체크박스 카운트 초기화.
        }catch (e) {
            promokit.message({
                type: 'alert',
                message: '답변하지 않은 문항이 있습니다.',
            });
        }
    }
});